import { useEffect, useState } from "react";
import api from "@/lib/apiClient";
import { Facebook, Instagram, Globe, Music2 } from "lucide-react";

const ICONS = [
  { key: "facebook", Icon: Facebook, label: "Facebook" },
  { key: "instagram", Icon: Instagram, label: "Instagram" },
  { key: "tiktok", Icon: Music2, label: "TikTok" },
  { key: "website", Icon: Globe, label: "Site web" },
];

export function useSettings() {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/settings").then(({ data }) => setSettings(data)).catch(() => {});
  }, []);
  return settings;
}

export function SocialLinks({ className = "", light = false }) {
  const settings = useSettings();
  const links = ICONS.filter((i) => settings?.social?.[i.key]);
  if (!links.length) return null;
  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid="social-links">
      {links.map(({ key, Icon, label }) => (
        <a
          key={key}
          href={settings.social[key]}
          target="_blank"
          rel="noreferrer"
          title={label}
          aria-label={label}
          className={`w-9 h-9 rounded-full flex items-center justify-center transition-colors ${light ? "text-white/80 hover:bg-white/15 hover:text-white" : "text-muted-foreground hover:text-rose-brand hover:bg-rosebrand-pale"}`}
          data-testid={`social-link-${key}`}
        >
          <Icon className="w-4 h-4" />
        </a>
      ))}
    </div>
  );
}
